import { render, staticRenderFns } from "./BookingFormSuccess.vue?vue&type=template&id=5e3c62a0&"
import script from "./BookingFormSuccess.vue?vue&type=script&lang=js&"
export * from "./BookingFormSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports